// extracted by mini-css-extract-plugin
export var container = "_97-0";
export var fallback = "_97-5";
export var fallbackIcon = "_97-6";
export var hidden = "_97-2";
export var image = "_97-3";
export var loaded = "_97-4";
export var placeholder = "_97-1";